var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui stacked blue segment"},[_c('div',{staticClass:"ql-editor",attrs:{"data-gram":"false","contenteditable":"true"},domProps:{"innerHTML":_vm._s(_vm.receipt_render)}}),_c('vue-editor',{staticClass:"hidden",model:{value:(_vm.dummy),callback:function ($$v) {_vm.dummy=$$v},expression:"dummy"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }